namespace RioERP.Enquiry {
    export interface EnquiryProductsPickerForm {
        EnquiryId: Serenity.LookupEditor;
    }

    export class EnquiryProductsPickerForm extends Serenity.PrefixedContext {
        static formKey = 'Enquiry.EnquiryProductsPickerForm';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!EnquiryProductsPickerForm.init)  {
                EnquiryProductsPickerForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;

                Q.initFormType(EnquiryProductsPickerForm, [
                    'EnquiryId', w0
                ]);
            }
        }
    }
}
